import React from 'react';
import { Tabs as AntTabs } from 'antd';
import styled from 'styled-components';

const StyledTabs = styled(AntTabs)`
  overflow: auto;

  .ant-tabs-nav {
    margin-bottom: 0;
    padding-left: 20px;
    padding-right: 20px;

    .ant-tabs-tab-active {
      .ant-tabs-tab-btn {
        color: var(--greyscale-blackish);
      }
    }
  }

  .ant-tabs-content-holder {
    overflow: auto;
  }

  &.administration-import-tabs {
    overflow-x: hidden;
    width: 100%;
  }
`;

export const Tabs = (props) => <StyledTabs {...props} />;
